/**
 * Configuration de l'entreprise Verphone
 *
 * Ce fichier centralise toutes les informations de l'entreprise.
 * Modifiez-le pour mettre à jour rapidement les données à travers tout le site.
 */

export const COMPANY_INFO = {
  // Informations de base
  name: 'Verphone',
  tagline: 'Réparation & Vente de Téléphones Reconditionnés',
  description:
    'Chaîne spécialisée dans la réparation de smartphones, proposant également des accessoires et des services de sauvegarde de données.',

  // Contact
  contact: {
    phone: '02 59 16 49 44',
    phoneFormatted: '+33 2 59 16 49 44',
    email: 'contact@verphone.net',
  },

  // Adresse
  address: {
    street: '8 Bis Pl. du Guesclin',
    zipCode: '22000',
    city: 'Saint-Brieuc',
    region: 'Bretagne',
    country: 'France',
  },

  // Informations légales
  legal: {
    siren: '989 168 216',
    siret: '989 168 216 00012',
    vat: 'FR53 989 168 216',
    legalForm: 'SARL',
    capital: '10 000,00 €',
    naf: '47.41Z',
    createdDate: '2025-07-08',
  },

  // Horaires d'ouverture
  businessHours: {
    monday: { open: '10:00', close: '19:00' },
    tuesday: { open: '10:00', close: '19:00' },
    wednesday: { open: '10:00', close: '19:00' },
    thursday: { open: '10:00', close: '19:00' },
    friday: { open: '10:00', close: '19:00' },
    saturday: { open: '10:00', close: '19:00' },
    sunday: { open: null, close: null }, // Fermé
  },

  // Couleurs de la marque
  colors: {
    primary: '#23994F',
    primaryDark: '#1a7840',
    secondary: '#3b82f6',
    accent: '#06b6d4',
  },

  // Réseaux sociaux (à ajouter quand disponibles)
  social: {
    facebook: 'https://facebook.com/verphone',
    twitter: 'https://twitter.com/verphone',
    instagram: 'https://instagram.com/verphone',
    linkedin: 'https://linkedin.com/company/verphone',
  },

  // Garanties et services
  warranty: {
    months: 12,
    description: 'Garantie 12 mois sur tous les produits reconditionnés',
  },

  // Avantages
  benefits: {
    savings: '50%',
    guaranteeMonths: 12,
    dataBackup: true,
    accessories: true,
  },
};

/**
 * Fonction utilitaire pour obtenir l'adresse formatée
 */
export const getFullAddress = () => {
  const { address } = COMPANY_INFO;
  return `${address.street}, ${address.zipCode} ${address.city}, ${address.region}, ${address.country}`;
};

/**
 * Fonction utilitaire pour obtenir les horaires formatés
 */
export const getFormattedHours = () => {
  const days = [
    { name: 'Lundi', key: 'monday' },
    { name: 'Mardi', key: 'tuesday' },
    { name: 'Mercredi', key: 'wednesday' },
    { name: 'Jeudi', key: 'thursday' },
    { name: 'Vendredi', key: 'friday' },
    { name: 'Samedi', key: 'saturday' },
    { name: 'Dimanche', key: 'sunday' },
  ];

  return days.map(({ name, key }) => {
    const hours = COMPANY_INFO.businessHours[key];
    return {
      day: name,
      hours: hours.open ? `${hours.open} - ${hours.close}` : 'Fermé',
    };
  });
};
